/**
 * MediaPlayback Styled Component
 */

import styled from 'styled-components';

const MediaPlaybackDiv = styled.div``;

export default MediaPlaybackDiv;
